import { useEffect, useState } from "react";
import { FirestoreService } from "../../../../../api/firebase/firestoreService";
import { FirestoreDocumentReference } from "../../../../../api/firebase/references";
import type { CmmInputUniqueValuesDoc } from "../../validationFunnel/pages/conditionList/cmmInputUniqueValuesTypes";
import { getFilenameBatchOptionsFromDoc } from "../utils/filenameBatchOptions";

/**
 * Loads batch dropdown options from the `filename` column in the condition list
 * document at `/flagging_algorithm_config/cmm_input_unique_values`.
 *
 * @return Filename top values, loading state, and fetch error when present.
 */
export function useFilenameBatchOptions() {
  const [options, setOptions] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let cancelled = false;

    const fetchFilenameOptions = async () => {
      setLoading(true);
      setError(null);
      try {
        const doc = await FirestoreService.getDocument<CmmInputUniqueValuesDoc>(
          FirestoreDocumentReference.flaggingAlgorithmCmmInputUniqueValues(),
        );
        if (!cancelled) {
          setOptions(getFilenameBatchOptionsFromDoc(doc));
        }
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err : new Error(String(err)));
          setOptions([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchFilenameOptions();
    return () => {
      cancelled = true;
    };
  }, []);

  return { options, loading, error };
}
